import type { Command } from './types';
import { useEditorStore } from '@/store/editorStore';

export const aiCommands: Command[] = [
  {
    id: 'ai.open',
    label: 'AI Assist',
    category: 'edit',
    canExecute: (ctx) => ctx.editorState.selectedNodeIds.length === 1,
    execute: (ctx) => {
      const store = useEditorStore.getState();
      const nodeId = ctx.editorState.selectedNodeIds[0];
      if (!nodeId) return;
      if (store.aiPanelNodeId === nodeId) {
        store.closeAiPanel();
      } else {
        store.openAiPanel(nodeId);
      }
    },
  },
  {
    id: 'ai.expand',
    label: 'AI Expand Ideas',
    category: 'edit',
    canExecute: (ctx) => ctx.editorState.selectedNodeIds.length === 1,
    execute: (ctx) => {
      const store = useEditorStore.getState();
      const nodeId = ctx.editorState.selectedNodeIds[0];
      if (!nodeId) return;
      store.openAiPanel(nodeId, 'expand');
    },
  },
];
